import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  Alert
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import cogoToast from 'cogo-toast';
import { connect } from "react-redux"

const NewVendor = props => {

  const history = useHistory();

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email1, setEmail1] = useState('');
  const [phone1, setPhone1] = useState('');
  const [email2, setEmail2] = useState('');
  const [phone2, setPhone2] = useState('');
  const [email3, setEmail3] = useState('');
  const [phone3, setPhone3] = useState('');
  const [address, setAddress] = useState('');
  const [status, setStatus] = React.useState(1);

  const [errors, setErrors] = React.useState([]);
  
  const [loading, setLoading] = React.useState(false);
  const [initializing, setInitializing] = React.useState(true);

  const fetchData = (id) => {
    setLoading(true);
      console.log('Fetching ', id);
      get(url.GET_VENDOR+'/'+id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setName(response.data.name);
        setPhone(response.data.phone);
        setEmail1(response.data.email1);
        setPhone1(response.data.phone1);
        setEmail2(response.data.email2);
        setPhone2(response.data.phone2);
        setEmail3(response.data.email3);
        setPhone3(response.data.phone3);
        setAddress(response.data.address);
        setStatus(response.data.status);
        setLoading(false);
      }
      else {
        cogoToast.error('Could not fetch vendor data');
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };


  const handleSubmit = () => {
    if(name == '') {
      cogoToast.error('Vendor name is required');
      return;
    }

    let data = {
      id: props.match.params.id ? props.match.params.id : 'new',
      name: name,
      phone: phone,
      email1: email1,
      phone1: phone1,
      email2: email2,
      phone2: phone2,
      email3: email3,
      phone3: phone3,
      address: address,
      status: status,
      block_id: props.filterBlock.id,
    };

    console.log('data', data);
    // return;

    setLoading(true);
    setErrors([]);
    // axios.post('/api/beacon/create', {
    post(url.POST_NEW_VENDOR, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        history.push('/vendors/index');
        cogoToast.success('Vendor '+ (props.match.params.id ? (props.match.params.id == 'new' ? 'added' : 'updated') : 'added') + ' successfully');
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
      // if(response == true) {
      // }
      // if(response.status == 200) {
      //   if(response.data == 'input') {
      //     cogoToast.error('Please check your input');
      //     setLoading(false);
      //   }
      //   else if(response.data == 'exists') {
      //     cogoToast.error('Beacon name is already taken');
      //     setLoading(false);
      //   }
      //   else {
      //     props.insertItem(response.data);
      //   }
      // }
      // else {
      //   cogoToast.error('Beacon could not be created');
      //   setLoading(false);
      // }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };

  React.useEffect(()=>{

    if(props.match.params.id && props.match.params.id !== 'new') {
      // setName(props.match.params.id.name);
      fetchData(props.match.params.id);
    }
  }, []);

  // console.log('params:', props.match.params.id);

  // const displayedBlocks = blocks.length < 1 ? [] : blocks.filter(b => property == null ? false : b.property_id == property.value);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.match.params.id ? (props.match.params.id == 'new' ? 'Add New' : 'Edit') : 'Add New'} Vendor | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">{props.match.params.id ? (props.match.params.id == 'new' ? 'New' : 'Edit') : 'New'} vendor</h3>
            <Link className="btn btn-secondary" to="/vendors/index">Back</Link>
          </div>


          {errors.length > 0 &&
          <div className="mt-3 mb-5">
            {errors.map((error, errorIdx)=>(
              <Alert key={errorIdx} color="danger">
                <i className="mdi mdi-alert-circle-outline me-2"></i>{error}
              </Alert>
            ))}
          </div>
          }

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row mt-2">
                <div className="col">
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label label-required">Vendor Name</label>
                    <div className="col-sm-9">
                      <input autoFocus type="text" className="form-control" value={name} onChange={e=>{ setName(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-5 row">
                    <label htmlFor="inputPhone" className="col-sm-3 col-form-label">Customer care Contact no.</label>
                    <div className="col-sm-9">
                      <input type="text" id="inputPhone" className="form-control" value={phone} onChange={e=>{ setPhone(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mt-3 mb-4 row">
                    <label htmlFor="inputEmail1" className="col-sm-3 col-form-label">Level 1 Email address</label>
                    <div className="col-sm-9">
                      <input type="text" id="inputEmail1" className="form-control" value={email1} onChange={e=>{ setEmail1(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="inputPhone1" className="col-sm-3 col-form-label">Level 1 Contact no.</label>
                    <div className="col-sm-9">
                      <input type="text" id="inputPhone1" className="form-control" value={phone1} onChange={e=>{ setPhone1(e.target.value); }} />
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label htmlFor="inputEmail2" className="col-sm-3 col-form-label">Level 2 Email address</label>
                    <div className="col-sm-9">
                      <input type="text" id="inputEmail2" className="form-control" value={email2} onChange={e=>{ setEmail2(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="inputPhone2" className="col-sm-3 col-form-label">Level 2 Contact no.</label>
                    <div className="col-sm-9">
                      <input type="text" id="inputPhone2" className="form-control" value={phone2} onChange={e=>{ setPhone2(e.target.value); }} />
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Level 3 Email address</label>
                    <div className="col-sm-9">
                      <input type="text" id="inputEmail3" className="form-control" value={email3} onChange={e=>{ setEmail3(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="inputPhone3" className="col-sm-3 col-form-label">Level 3 Contact no.</label>
                    <div className="col-sm-9">
                      <input type="text" id="inputPhone3" className="form-control" value={phone3} onChange={e=>{ setPhone3(e.target.value); }} />
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label htmlFor="inputAddress" className="col-sm-3 col-form-label">Address</label>
                    <div className="col-sm-9">
                      <textarea id="inputAddress" rows={3} className="form-control" value={address} onChange={e=>{ setAddress(e.target.value); }} />
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label htmlFor="status" className="col-sm-3 col-form-label">Status</label>
                    <div className="col-sm-9">
                      <select className="form-control" placeholder="Select one" 
                        value={status}
                        onChange={(e)=>{ setStatus(e.target.value); }}
                        >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>


     </Container>

    <div className="mb-4 container">
      <div className="d-flex justify-content-center">
        <button type="button" className="btn btn-primary me-2" onClick={()=>{ handleSubmit(); }}>Submit</button>
        <Link className="btn btn-light" to="/vendors/index">Cancel</Link>
      </div>
    </div>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(NewVendor)